// extracted by mini-css-extract-plugin
export default {"dashboardTitle":"Dashboard_dashboardTitle__BzwfO","pageContent":"Dashboard_pageContent__9g3bV"};